var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNgaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1734_41355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 3.3335C1.95942 3.3335 1.28115 3.61445 0.781049 4.11454C0.280952 4.61464 0 5.29292 0 6.00016L0 18.0002C0 18.7074 0.280952 19.3857 0.781049 19.8858C1.28115 20.3859 1.95942 20.6668 2.66667 20.6668H8V3.3335H2.66667Z",
    fill: "#32D16D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.3335H16V20.6668H8V3.3335Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 3.3335H16V20.6668H21.3333C22.0406 20.6668 22.7189 20.3859 23.219 19.8858C23.719 19.3857 24 18.7074 24 18.0002V6.00016C24 5.29292 23.719 4.61464 23.219 4.11454C22.7189 3.61445 22.0406 3.3335 21.3333 3.3335Z",
    fill: "#32D16D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1734_41355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgaFlag);
export default __webpack_public_path__ + "static/media/nga_flag.16396d1801881047f9eb5231f00632dc.svg";
export { ForwardRef as ReactComponent };